// src/components/myteconstruction/OrganizationDashboard/dashboardDummyData.js
// Centralised mock‑data for the Digital Playground dashboard.
// Swap these with real API calls once live.

import {
  FileText,
  TrendingUp,
  TrendingDown,
  Percent,
  DollarSign,
  BarChart3,
} from "lucide-react"

export const kpiData = [
  {
    title: "Total Bids Submitted",
    value: "45",
    delta: "+12 from last month",
    deltaPositive: true,
    icon: FileText,
  },
  {
    title: "Bids Won",
    value: "18",
    delta: "-2 from last month",
    deltaPositive: false,
    icon: TrendingUp,
  },
  {
    title: "Bids Lost",
    value: "12",
    delta: "+3 from last month",
    deltaPositive: false,
    icon: TrendingDown,
  },
  {
    title: "Win Rate",
    value: "40%",
    delta: "-5% from last quarter",
    deltaPositive: false,
    icon: Percent,
  },
  {
    title: "Average Bid Value",
    value: "$650K",
    delta: "+15% vs last quarter",
    deltaPositive: true,
    icon: DollarSign,
  },
  {
    title: "Total Bid Value",
    value: "$29.3M",
    delta: "+$4.2M vs last quarter",
    deltaPositive: true,
    icon: BarChart3,
  },
]

export const projectOverview = [
  {
    name: "Downtown Tower",
    progress: 65,
  },
  {
    name: "Riverside Bridge",
    progress: 42,
  },
  {
    name: "City Hospital Expansion",
    progress: 81,
  },
  {
    name: "Metro Station Renovation",
    progress: 30,
  },
]

export const upcomingDeadlines = [
  {
    id: "BID‑1239",
    projectName: "Metro Station Renovation",
    client: "Transit Authority",
    dueDate: "2025-05-15",
    daysLeft: 2,
  },
  {
    id: "BID‑1240",
    projectName: "University Science Building",
    client: "State University",
    dueDate: "2025-05-18",
    daysLeft: 5,
  },
  {
    id: "BID‑1241",
    projectName: "Shopping Mall Expansion",
    client: "Retail Developers Inc.",
    dueDate: "2025-05-22",
    daysLeft: 9,
  },
]

// Feel free to extend with ActiveBids, CurrentBids, Pipeline etc.
